import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from './../../shared/services/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-tenant-sign-in',
  template: `
  <div class="h-100 tenant-signin">
    <div class="d-flex pt-4">
      <div class="flex-fill flex-column text-center">
        <div>
          <img src="assets/images/logo-zazz.png" class="img-fluid mt-5 text-center pt-5" width="74px" alt="ZAZZ">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="flex-grow-2 p-3 mt-5" style="width: 320px;">
        <h2 class="text-center text-light mb-0 mt-5 mb-3">Bienvenido</h2>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <div class="form-group text-start mt-5">
            <label for="email" class="text-sm sr-only d-none">Correo electrónico</label>
            <input type="text" formControlName="email" class="form-control border-2 rounded-0 border-white border-top-0 border-start-0 border-end-0 bg-transparent text-white pt-3 pb-3" placeholder="Correo electrónico" #userName required>
            <div *ngIf="lf['email'].touched && lf['email'].invalid">
              <div *ngIf="lf['email'].errors?.['required']" class="text-danger text-sm">El correo electrónico es requerido.</div>
              <div *ngIf="lf['email'].errors?.['email']" class="text-danger text-sm">El correo electrónico no es válido</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="password" class="text-sm sr-only d-none">Contraseña</label>
            <input type="password" formControlName="password" class="form-control border-2 rounded-0 border-white border-top-0 border-start-0 border-end-0 bg-transparent text-white pt-3 pb-3" placeholder="Contraseña" #userPassword required>
            <div *ngIf="lf['password'].touched && lf['password'].invalid">
              <div *ngIf="lf['password'].errors?.['required']" class="text-danger text-start text-sm">La contraseña es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <div class="form-check text-start">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [value]="terms" (change)="terms = !terms">
              <label class="form-check-label text-start text-sm text-light" for="flexCheckDefault">
              Al seleccionar esta casilla acepto los términos y condiciones zazz.mx.
              </label>
            </div>
          </div>
          <div class="form-group mt-5">
            <button type="submit" [disabled]="!terms" class="btn btn-lg w-100 rounded-3 bg-transparent border border-2 border-white text-white pt-3 pb-3">
              <fa-icon [icon]="faCircleNotch" animation="spin" *ngIf="loading" class="text-white me-2"></fa-icon>
              <fa-icon [icon]="faLock" *ngIf="!loading" class="text-white me-2"></fa-icon>
              Entrar
            </button>
          </div>
        </form>
        <div class="forgotPassword mt-5 text-center">
          <a routerLink="/forgot-password" class="text-sm">¿Olvidaste tu contraseña?</a>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="mt-5 pt-5">
        <a href="https://zazz.mx/aviso-de-privacidad/" class="text-sm mt-5">Aviso de privacidad</a> <span class="text-sm mt-5 ps-3 pe-3"> | </span>
        <a href="https://zazz.mx/terminos-y-condiciones/" class="text-sm mt-5">Términos y condiciones</a>
      </div>
    </div>
  </div>
  `,
  styleUrls: []
})
export class TenantSignInComponent implements OnInit {
  loginForm!: FormGroup;
  terms: boolean = false;
  loading: boolean = false;
  
  protected version = environment.app_version;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  faCircleNotch = faCircleNotch;
  faLock = faLock;
  storageService = inject(StorageService);
  constructor(
    public authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private store: SettlementsService,
    private router: Router
  ) { }

  get lf() {
    return this.loginForm.controls;
  }

  get email() {
    return this.loginForm.get('email');
  }
  
  ngOnInit(): void { 
    if (this.storageService.getItem(STORAGE_KEYS.TOKEN)) {
      this.router.navigate(['tentant/dashboard']);
    }

    this.initLoginForm();
  }

  private initLoginForm(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  login () {
    this.loading = true;
    if (this.loginForm.invalid) {
      this.toastr.error('No está completa la información.', 'Error');
      this.loading = false;
      return;
    }

    let payload = {
      user: {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password
      }
    };

    this.store.tenantLogin(payload).subscribe({
      next: (data: any) => {
        console.log("ROLE ???? ", data);
        if (this.SetUserData(data)) {

          this.store.getRole(data.data.role_id).subscribe({
            next: (data: any) => {
              console.log("ROLE DATA ===> ", data);
              this.storageService.saveItem(STORAGE_KEYS.ROLE, JSON.stringify({ role: data}));
              this.storageService.saveItem(STORAGE_KEYS.PERMISSIONS, data.permissions);
              this.storageService.saveItem(STORAGE_KEYS.USERTYPE, 'tenant');

              this.router.navigate(['tenant/dashboard']);
            }, error: (e: any) => {
              console.error("Error fetching role data: ", e);
            }
          });
          // window.location.reload();
        } else {
          this.toastr.error('Credenciales incorrectas, revisa tus datos e intenta de nuevo', 'Error');
          this.loading = false;
        }
      },
      error: (error: any) => {
        this.toastr.error('Credenciales incorrectas, revisa tus datos e intenta de nuevo', 'Error');
        this.loading = false;
      }
    });
  }

  SetUserData(user: any) {
    console.log("user ====> ", user);
    const userData: any = {
      id: user.data.id,
      email: user.data.email,
      name: user.data.name,
      last_name: user.data.last_name,
      jti: user.data.jti,
      role_id: user.data.role_id,
      profile_id: user.data.profile_id,
      avatar: user.avatar
    };

    console.log("userData", userData.role_id);

    this.storageService.saveItem(STORAGE_KEYS.TOKEN, user.token);
    this.storageService.saveItem(STORAGE_KEYS.USER, JSON.stringify(userData));

    return true;
  }
}
